<template>
    <div class="card-expandido">
        <div class="title-expanded">
            <h2>{{ titulo }}</h2>
        </div>

        <button class="btn-fechar" @click="$emit('fechar')"><i class="fa-solid fa-times"></i></button>

        <div class="pdf-grid-content">

            <div v-if="!loading && semConteudo" class="sem-conteudo">
                <i class="fa-solid fa-box-open" style="font-size: 30px; display: block; margin-bottom: 15px; color: rgba(255,255,255,0.4);"></i>
                Nenhum conteúdo disponível no momento.
            </div>

            <template v-if="tipo === 'material-didatico'">
                <CardBook v-for="pdf in items" :key="pdf.codigo_aula" :book="pdf" @details="viewDocumento" @add-to-cart="encaminharParaCarrinho" />
            </template>

            <template v-if="tipo === 'video-aula'">
                <CardVideo v-for="video in items" :key="video.codigo_aula" :video="video" @add-to-cart="encaminharParaCarrinho" />
            </template>

            <template v-if="tipo === 'atividade'">
                <CardSimulated v-for="(simulado, index) in items" :key="simulado.codigo_aula" :simulado="simulado" :numero="index + 1" @add-to-cart="encaminharParaCarrinho" />
            </template>

        </div>

        <a class="btn-adquirir" @click.stop="addToCart">
            <span class="title-btn-adquirir"><i class="fa-solid fa-cart-shopping"></i> Adquirir o pacote inteiro</span>
        </a>
    </div>
</template>

<script>
import request from '../router/request'
import CardBook from '../components/CardBook.vue';
import CardVideo from '../components/CardVideo.vue';
import CardSimulated from './CardSimulated.vue';
import { getFullPackagePriceByType } from '@/utils/pricing';

export default {
    name: "ExpandedCard",
    components: {
        CardBook,
        CardVideo,
        CardSimulated
    },
    props: {
        tipo: String,
        titulo: String,
        codigo: {
            type: [Number, String],
            required: true
        },
    },
    data() {
        return {
            loading: false,
            conteudo: [],
            items: [],
            pdfs: [],
            showModal: false,
            viewDoc: "",
            pdfLista: [],
            currentPDF: 0,
            objetoVisualizar: null,
            disciplineName: "",
            semConteudo: false,
        };
    },
    watch: {
        codigo: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.mountCardBooks();
                }
            }
        }
    },
    methods: {
        viewDocumento(item) {
            this.showModal = true;
            this.viewDoc = '';
            this.pdfLista = [];
            this.currentPDF = 0;
            this.objetoVisualizar = item;

            request.post("ava/obterAulasDiciplina", {
                codigo_disciplina: item.codigo_disciplina
            }).then(response => {
                if (!response.data || response.data.length === 0) {
                    console.log("Nenhum PDF encontrado para esta disciplina.");
                    return;
                }
                this.pdfLista = response.data;
                this.carregarPdfAtual();
            });
        },
        carregarPdfAtual() {
            const pdf = this.pdfLista[this.currentPDF];
            request.post("arquivo/prepararDownload", {
                ano_mes_dia_arq: pdf.amd_arq_pdf_aula,
                hash_arquivo: pdf.hash_arq_pdf_aula,
            }).then(resp => {
                this.viewDoc = "/api/arquivo/download?hash=" + resp.data.hash;
            });
        },
        mountCardBooks() {
            this.loading = true;

            switch (this.tipo) {
                case 'material-didatico':
                    this.carregarMaterialDidatico();
                    break;

                case 'video-aula':
                    this.carregarVideoAulas();
                    break;

                case 'atividade':
                    this.carregarAtividades();
                    break;
            }
        },
        carregarMaterialDidatico() {
            this.loading = true;
            this.semConteudo = false;

            request.post('ava/obterAulasDiciplina', {
                codigo_disciplina: this.codigo
            })
                .then(res => {
                    this.items = res.data || [];
                    this.semConteudo = this.items.length === 0;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        carregarVideoAulas() {
            this.loading = true;
            this.semConteudo = false;

            request.post('asas/listarVideoAulas', {
                codigo_disciplina: this.codigo
            })
                .then(res => {
                    this.items = res.data || [];
                    this.semConteudo = this.items.length === 0;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        carregarAtividades() {
            this.loading = true;
            this.semConteudo = false;

            request.post('asas/listarSimulado', {
                codigo_disciplina: this.codigo
            })
                .then(res => {
                    this.items = res.data || [];
                    this.semConteudo = this.items.length === 0;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        encaminharParaCarrinho(item) {
            this.$emit('add-to-cart', item);
        },
        addToCart(event) {
            event.stopPropagation();

            const packageItem = {
                codigo_disciplina: this.codigo,
                nome_disciplina: `Pacote de ${this.titulo}`,
                url_imagem: null,
                preco: getFullPackagePriceByType(this.tipo),
                tipo: `pacote-${this.tipo}`,
                isPacote: false
            };

            this.$emit('add-to-cart', packageItem);
        },
        irParaVideo() {
            this.$router.push({
                path: '/video',
                query: {
                    hash: this.video.url_video_aula
                }
            });
        }
    },
    mounted() {
        window.scrollTo(0, 0);

        this.mountCardBooks();
    },
};
</script>
